import React from 'react'
import styled from 'styled-components'
import Product from './Product'
import { useAuthStore } from '../store/store';
import { NavLink } from 'react-router-dom';

const GridView = ({products}) => {
     const {auth}=useAuthStore();  
  return (
   <Wrapper className="section">
    
    <div className="product-container">      
        {products.map((curElem)=>{
        return <Product key={curElem.id} {...curElem}/>;
            })
        }
    </div>
 
   </Wrapper>
  )
}
const Wrapper = styled.section`
  padding: 1rem 0; 

 .product-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 3.2rem;
    padding:1.5rem;    
    max-width: 120rem;
    max-height: 80vh;   
    overflow-y: auto;    
    }

  .card {
    border-radius: 1rem;
    box-shadow:2px 2px 2px 2px #d1d1d1;   
    }
       
  figure {
    background:#fff;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin:1rem;
    border-radius: 2rem;
    overflow: hidden;
    transition: all 0.5s linear;   
    
   
   img {
      max-width: 100%;
      height: 15rem;
      margin-top: 4rem;
      transition: transform 0.3s ease;
     }
  
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 0%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      transition: all 0.2s linear;
      cursor: pointer;
      }
  
    &:hover::after {
      width: 100%;
      }

    &:hover img {
      transform: scale(1.2);
      }   
   }

  .card-data {
    padding: 0 8%;
    }

  .card-data-flex {
    display: flex;
    justify-content: space-between;
    gap : 1rem;
    margin: 1rem 0;      
    }

  .card-data--price {
    font-weight: 400;
    color: rgb(14, 96, 249);
    }

  h3 {
    color: ${({ theme }) => theme.colors.font};
    text-transform: capitalize;
    }
  
     
  Button{
    margin: 1rem;
    width : 12rem;
    }   

  @media (max-width: ${({ theme }) => theme.media.mobile}) {
  padding: 0;

 .product-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
    padding: 1rem;
    max-height: 100%; 
    }

  figure {
    .caption {    
    top: 3%;
    text-align:center;
    padding: 0.3rem ;
    font-size: 1.5rem;
    }
  
  img {
    height: 10rem;
    margin-top: 4rem;    
    }
  }

  .common-heading {
    font-size: 2.5rem;
    margin-bottom: 2.5rem;
    }

  .card-data-flex {
    margin: 1rem;
    }
    
  .card-data {
    padding: 0;
    }

  h3,
  p {
    font-size: 1.3rem;
    }
  
  Button{
    width : 6rem;
    margin: 1rem;
    padding: 0.7rem 0.9rem;
    font-size: 1rem;
    border-radius: 0.4rem;   
    }  
  }   
`;

export default GridView
